import { createFileRoute, redirect } from "@tanstack/react-router"
import { getLocationById } from "@/api/services/locations"
import { locationQueryKeys } from "@/api/query-keys/locations"
import { checkPermissions } from "@/utils/checkPermissions"

export const Route = createFileRoute("/beheer/locaties/$locationId/")({
  beforeLoad: async ({ params, context }) => {
    checkPermissions("read", "locations")
    const { queryClient } = context

    const { data: location } = await queryClient.fetchQuery({
      queryKey: locationQueryKeys.detail(Number(params.locationId)),
      queryFn: () => getLocationById(Number(params.locationId)),
    })

    if (location.classrooms.length > 0) {
      const firstClassroom = location.classrooms[0]
      throw redirect({
        to: "/beheer/locaties/$locationId/classrooms/$classroom",
        params: {
          locationId: params.locationId,
          classroom: firstClassroom.id.toString(),
        },
      })
    } else {
      throw redirect({
        to: "/beheer/locaties/$locationId/notities",
        params: { locationId: params.locationId },
      })
    }
  },
})
